import '../styles/Home.css'

export default function Home(){
    return (
        <>
        <div className='home-main'>
        <h1 className='head'>How to help a stray pet?</h1>

            <div className='main-1'>
                <div className='guide g1'>
                <img src='https://cdn.pixabay.com/photo/2016/12/01/20/05/boy-and-dog-1876072_960_720.jpg' alt=''/>
                <div className='txt'>
                    <h2>Safety first</h2>
                    <p>A strange, frightened, and possibly sick or injured animal can behave unpredictably. A sudden move on your part, even opening your car door, can spook them and cause them to bolt—possibly right onto the highway. If the animal looks or acts threatening, or if you feel uneasy about the situation, stay in your car.
If possible, restrain the animal. Create a barrier or use a carrier, leash, piece of cloth, or length of rope to keep the animal in the area. Signal approaching vehicles to slow down if you cannot confine the animal, or divert traffic around them if they appear to be injured and is still on the roadway.</p>
                    </div>
                </div>
                <div className='guide g2'>
                <div className='txt'>
                    <h2>Use caution</h2>
                    <p>Use caution when approaching the animal. Should you succeed in getting close enough to capture them, you stand a good chance of being scratched or bitten.

When moving toward the animal, speak calmly to reassure them. Make sure they can see you at all times as you approach, and perhaps entice them to come to you by offering strong-smelling food such as canned tuna or dried liver.</p>
                </div>
                <img src='https://1721181113.rsc.cdn77.org/data/images/full/26936/stray-dogs.jpg'alt=''/>
                </div>
                <div className='guide g3'>
                <img src='https://cdn.pixabay.com/photo/2016/10/31/14/55/rottweiler-1785760_960_720.jpg ' alt=''/>
                   <div className='txt'> <h2>Call for backup</h2>
                    <p>f you're not able to safely restrain the animal, call the local animal control agency (in rural areas, call the police). Do so whether or not the animal is injured, and whether or not they are wearing an identification tag. Leave your phone number with the dispatcher, and try to get an estimate of how long it may take someone to respond. If possible, stay on the scene to keep an eye on the dog or cat until help arrives. Make sure you report to authorities precisely where the animal is by using road names, mile markers or landmarks.</p>
                    </div>
                </div>
            </div>
            <div className='guide g2'>
                <div className='txt'>
                    <h2>Visiting a veterinarian</h2>
                    <p>Before you take an injured animal to a private veterinary hospital for treatment, be willing to assume financial responsibility for the animal. Good care is not cheap, and many veterinarians have many Samaritans in their waiting rooms every year. Anyone who is committed to trying to save injured stray animals should discuss these issues in advance with the veterinarian.</p>
                </div>
                <img src='https://cdn.pixabay.com/photo/2017/12/09/19/22/dog-3008459_960_720.jpg' alt=''/>
                </div>

        </div>
        </>
    )
}